module.exports = __webpack_public_path__ + "img/sb.aa819297.svg";